<ng-container *ngIf="readOnly; else editing">
  <span class="content">{{ customDataConfig?.text }}</span>
</ng-container>

<ng-template #editing>
  <ng-container [formGroup]="form">
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'EDIT_KNOWLEDGE.NAME' | translate }}</glxy-label>
      <input matInput formControlName="name" />
      <glxy-error *ngIf="form.get('name')?.hasError('required') && form.get('name')?.dirty">
        {{ 'EDIT_KNOWLEDGE.REQUIRED_FIELD' | translate }}
      </glxy-error>
    </glxy-form-field>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'EDIT_KNOWLEDGE.CUSTOM_DATA_CONFIG.CONTENT' | translate }}</glxy-label>
      <glxy-label-hint class="content-hint">{{
        'EDIT_KNOWLEDGE.CUSTOM_DATA_CONFIG.CONTENT_HINT' | translate
      }}</glxy-label-hint>
      <textarea class="content-input" matInput formControlName="content" rows="10"></textarea>
      <glxy-error *ngIf="form.get('content')?.hasError('required') && form.get('content')?.dirty">
        {{ 'EDIT_KNOWLEDGE.REQUIRED_FIELD' | translate }}
      </glxy-error>
    </glxy-form-field>
  </ng-container>
</ng-template>
